import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import {
  CloseIcon,
  FilterIcon,
  filterBlackIcon,
} from "../../../../assets/images";
import type { SelectOption } from "../../../../commonTypes/billOfMaterial";
import type { FilterDataType } from "../../../../redux/invoiceGeneration/invoiceGenrationTypes";

type AppProps = {
  handleFilter?: (type: string) => void;
  setSelectedBranch?: (type: SelectOption) => void;
  handleBranchChange?: () => void;
  setOffset?: React.Dispatch<React.SetStateAction<number>>;
  selectedBranch?: SelectOption;
  setBranchText?: React.Dispatch<React.SetStateAction<string>>;
  filterData?: FilterDataType;
  applyFilter?: boolean;
  branchOption?: SelectOption[] | [];
  fetching?: boolean;
  setFilterData?: React.Dispatch<React.SetStateAction<FilterDataType>>;
  allStockItemOption?: SelectOption[];
  handleFilterInputChange?: (data: any, type: string) => void;
  selectedFilterData?: FilterDataType;
  checkStockItemTypeBottom?: () => void;
  setStockItemText?: React.Dispatch<React.SetStateAction<string>>;
  setSelectedFilterData?: React.Dispatch<React.SetStateAction<FilterDataType>>;
  setApplyFilter?: React.Dispatch<React.SetStateAction<boolean>>;
};

const Filter = ({
  handleFilter,
  filterData,
  fetching,
  branchOption,
  allStockItemOption,
  handleFilterInputChange,
  selectedFilterData,
  setStockItemText,
  checkStockItemTypeBottom,
  setSelectedFilterData,
  setFilterData,
  setOffset,
  setSelectedBranch,
  setBranchText,
  selectedBranch,
  handleBranchChange,
  applyFilter,
  setApplyFilter,
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  const handleSubmit = () => {
    setOffset?.(0);
    handleFilter?.("Add");
  };
  const clearFilter = () => {
    setOffset?.(0);
    setApplyFilter?.(false);
    setSelectedBranch?.({
      label: "Select..",
      value: "",
    });
    handleFilter?.("Clear");
    setFilterData?.((prev: FilterDataType) => ({
      ...prev,
      primaryItem: { label: "Select...", value: null },
    }));
    setSelectedFilterData?.((prev: FilterDataType) => ({
      ...prev,
      primaryItem: { label: "Select...", value: null },
    }));
  };

  const handleBranchFilter = (data: { label: string; value: string }) => {
    setSelectedBranch?.({
      label: data?.label,
      value: data?.value,
    });
  };

  const resetFilterData = () => {
    if (!selectedFilterData?.primaryItem?.value) {
      setFilterData?.((prev: FilterDataType) => ({
        ...prev,
        primaryItem: { label: "Select...", value: null },
      }));
    }
    if (!applyFilter) {
      setSelectedBranch?.({
        label: "Select..",
        value: "",
      });
    }
  };

  const showPrimaryItemFilter = !!allStockItemOption;
  const showBranchFilter = !!branchOption;

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        resetFilterData();
        setToggle(!toggle);
      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={<Tooltip id="button-view-filter-invoice">Filter</Tooltip>}
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            filterData?.primaryItem?.value || applyFilter
              ? {
                  color: "#dd4433",
                  border: "1px solid #dd4433",
                  backgroundColor: "#fff6f5",
                }
              : { border: "1px solid#bfcbe1" }
          }
          outline
        >
          <img
            src={toggle ? FilterIcon : filterBlackIcon}
            alt=""
          />
        </DropdownToggle>
      </OverlayTrigger>

      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
              }}
            >
              <img
                src={CloseIcon}
                alt=""
              />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          {showPrimaryItemFilter ? (
            <div className="mt-4 ml-1">
              <h4>Select Primary Item</h4>
              <div>
                <div>
                  <Select<any, false>
                    classNamePrefix="react-select"
                    // inputProps={{ autoComplete: "nope" }}
                    options={allStockItemOption}
                    className={`react-select`}
                    value={filterData?.primaryItem}
                    onChange={(e: any) => {
                      handleFilterInputChange?.(e, "primaryItem");
                    }}
                    isSearchable
                    isLoading={fetching}
                    onMenuScrollToBottom={checkStockItemTypeBottom}
                    onInputChange={(e) => {
                      setStockItemText?.(e);
                    }}
                  />
                </div>
              </div>
            </div>
          ) : null}
          {showBranchFilter ? (
            <div className="mt-4 ml-1">
              <h4>Branch</h4>
              <div>
                <div>
                  <Select<any, false>
                    classNamePrefix="react-select"
                    // inputProps={{ autoComplete: "nope" }}
                    options={branchOption}
                    className={`react-select`}
                    value={selectedBranch}
                    onMenuClose={() => setBranchText?.("")}
                    onChange={(e: any) => {
                      handleBranchFilter?.(e);
                    }}
                    isSearchable
                    isLoading={fetching}
                    onInputChange={(e: any) => {
                      setBranchText?.(e);
                    }}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>

        <div className="d-flex align-items-center justify-content-end pb-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              setToggle?.(!toggle);
              // when the primary item filter is present it owns the apply, and applies the
              // branch selection along with it - handleBranchChange is the branch-only variant
              showPrimaryItemFilter ? handleSubmit() : handleBranchChange?.();
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default Filter;
